import { doRequest, doMultipleRequest } from '../../api/index';
import { NEWS_TYPES } from '../../constants';

const state = {
  list: {
    best: {},
    latest: {},
    unpublished: {},
    messages: {}
  },
  detail: {}
};

const getters = {};

const actions = {
  loadNewsList({ commit }, args) {
    if (args.type === NEWS_TYPES.BEST) {
      return doRequest('news.mostViewed', args)
        .then((data) => {
          commit('setBestNewsListData', {
            page: args.page,
            data
          });
        });
    }

    if (args.category === 'message') {
      return doRequest('news.list', args)
        .then((data) => {
          commit('setMessagesListData', {
            page: args.page,
            data
          });
        });
    }

    return doRequest('news.list', args)
      .then((data) => {
        commit('setNewsListData', {
          page: args.page,
          data
        });
      });
  },
  loadUnpublishedNewsList({ commit }, args) {
    return doRequest('news.unpublished', args)
      .then((data) => {
        commit('setUnpublishedNewsListData', {
          page: args.page,
          data
        });
      });
  },
  loadUnpublishedNewsDetail({ commit }, args) {
    return doRequest('news.unpublishedDetail', args)
      .then((data) => {
        commit('setNewsDetail', {
          slug: args.slug,
          data
        });
      });
  },
  loadNewsDetail({ commit }, args) {
    return doRequest('news.detail', args)
      .then((data) => {
        commit('setNewsDetail', {
          slug: args.slug,
          data
        });
      });
  },
  createNews({ commit }, args) {
    return doRequest('news.create', args)
      .then((data) => {
        commit('clearStorageNews');
        return data;
      });
  },
  editNews({ commit }, args) {
    return doRequest('news.edit', args)
      .then((data) => {
        commit('clearStorageNews');
        return data;
      });
  }
};

const mutations = {
  setNewsListData(s, data) {
    s.list.latest = Object.assign({}, s.list.latest, {
      [data.page]: data.data
    });
  },
  setMessagesListData(s, data) {
    s.list.messages = Object.assign({}, s.list.messages, {
      [data.page]: data.data
    });
  },
  setBestNewsListData(s, data) {
    s.list.best = Object.assign({}, s.list.best, {
      [data.page]: data.data
    });
  },
  setNewsDetail(s, data) {
    s.detail = Object.assign({}, s.detail, {
      [data.slug]: data.data
    });
  },
  setUnpublishedNewsListData(s, data) {
    s.list.unpublished = Object.assign({}, s.list.unpublished, {
      [data.page]: data.data
    });
  },
  clearStorageNews(s) {
    s.detail = {};
    s.list.best = {};
    s.list.latest = {};
  }
};


export default {
  state,
  getters,
  actions,
  mutations,
};
